import React from 'react';
import '../Styles/BankDetails.css';
import qrcode from '../Images/download.png';
import onlinepayment from '../Images/onlinepayment.png';

const BankDetails = () => {

    return (
        <div>
            
            <div className ="bank-details">
                <div className ="neft-details">
                    <h4>IMPS/NEFT/RTGS</h4>
                    <div className ="row-element">
                        <div>Account Name:</div>
                        <div>MMS TOURISM</div>
                     </div>
                    <hr/>
                    <div className ="row-element">
                        <div>Account No:</div>
                        <div> 257861102108
                        </div>
                     </div>
                    <hr/>
                    <div className ="row-element">
                        <div>Account Type:</div>
                        <div>CURRENT ACCOUNT</div>
                     </div>
                    <hr/>
                    <div className ="row-element">
                        <div>Bank Name:</div>
                        <div>INDUSIND BANK
                        </div>
                     </div>
                    <hr/>
                    <div className ="row-element">
                        <div>IFSC Code:</div>
                        <div>INDB0000470</div>
                    </div>
                    <div className="bank-note highlight-note">
  Please mail us with the transfer details to process account top-up sucessfully..
</div>
                    {/* <div className ="bank-note">Note: If using ICICI Bank, Please use 'Other Bank' option to add AIR IQ as beneficiary.</div>
                </div>
                <div className = "qrcode">
                    <div>
                   <img src ={qrcode} alt ="QR Code" className="qrimg"></img>
                    <div>ID: airiqicici</div>
                    <div className="bank-note">Note: Please send upload request after transfer with proper reference id. </div>
                    <img src ={onlinepayment} alt ="Online Payment Option" className="paymentimg"></img>
                    </div>*/}
                </div> 
            </div>
        </div>
    )

};

export default BankDetails;